// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__8y6AJ","tooltip-pop-in":"Tooltip_tooltip-pop-in__yg_T6"};